export const en = {
    "button-save": "Save",
    "checkbox-global-message": "Receive global messages and service news",
    "checkbox-notifications": "Receive service notifications",
    "changes-save-success": "Changes saved",
    "description-receive-global-yandex": "By choosing the subscription \"Global Messages and news of services\", I confirm my consent to receive advertising and\nother marketing messages from YANDEX LLC [Privacy Policy] and [User Agreement].",
    "description-receive-global-yango": "By choosing the subscription \"Global Messages and news of services\", I confirm my consent to receive advertising and\nother marketing messages from YANGO LLC [Privacy Policy] and [User Agreement].",
    "error": "An error has occurred",
    "header-email": "Email Notification Settings",
    "header-settings": "Settings",
    "tab-title-general-settings": "General settings",
    "try-again": "Try again in 10 seconds",
    "sent": "Sent",
    "too-common-error": "This is too vague. Please clarify or confirm.",
    "email-confirmation-error": "An error occurred during verification. You may not be logged in, or the link may have expired.",
    "email-confirmation-already-confirmed": " The email address for this [skill] has already been verified.",
    "email-confirmation-success": "The email address for [skill] has been successfully verified",
    "unsubscribe-success": "You have been unsubscribed from all notifications.",
    "unsubscribe-fail": "Unsubscribing failed. You may not be logged in, or the link may have expired.",
} as const;
export const ru = {
    "button-save": "Сохранить",
    "checkbox-global-message": "Получать глобальные сообщения и новости сервисов",
    "checkbox-notifications": "Получать сервисные уведомления",
    "changes-save-success": "Изменения сохранены",
    "description-receive-global-yandex": "Выбирая подписку «Глобальные сообщения и новости сервисов», я подтверждаю свое согласие на получение рекламных и\nиных маркетинговых сообщений от ООО «ЯНДЕКС» [Политики конфиденциальности] и [Пользовательского соглашения].",
    "description-receive-global-yango": "Выбирая подписку «Глобальные сообщения и новости сервисов», я подтверждаю свое согласие на получение рекламных и\nиных маркетинговых сообщений от Yango [Политики конфиденциальности] и [Пользовательского соглашения].",
    "error": "Произошла ошибка",
    "header-email": "Настройки email-уведомлений",
    "header-settings": "Настройки",
    "tab-title-general-settings": "Общие настройки",
    "try-again": "Попробуйте через 10 секунд",
    "sent": "Отправлено",
    "too-common-error": "Слишком общее. Переформулируйте его, либо подтвердите",
    "email-confirmation-error": "Произошла ошибка при подтверждении. Возможно, вы не авторизованы, или ссылка устарела.",
    "email-confirmation-already-confirmed": "Для данного [навыка] адрес уже подтвержден",
    "email-confirmation-success": "Email [навыка] успешно подтвержден",
    "unsubscribe-success": "Вы отписаны от всех уведомлений.",
    "unsubscribe-fail": "Не получилось отписаться. Возможно, вы не авторизованы, или ссылка устарела.",
} as const;
